// Evaluates a layer's preset `anims` list (show/hide entries keyed to a
// clip + "start"/"middle"/"end") against the current playhead — exact port
// of the reference's pointOf/clipPoint/sortedAnims/evalState. Shared by any
// card whose visibility is driven by this scheme (TextCard, VideoCard),
// rather than each one re-deriving clip-boundary frame numbers by hand the
// way World's own intro-reveal check currently does.

// Frame at which a clip boundary trigger actually fires. "middle" is the
// clip's own midpoint; "end" backs off half a frame so it fires just
// before the NEXT clip's frame is reached; "start" leads by half a frame
// UNLESS the previous clip ends exactly where this one begins (contiguous
// clips), in which case it aligns with "end" from the other side instead
// of double-firing on the shared boundary frame.
function clipPoint(clip, clips, which) {
  if (which === "middle") return (clip.from + clip.to) / 2;
  if (which === "end") return clip.to - 0.5;

  const i = clips.indexOf(clip);
  const prev = i > 0 ? clips[i - 1] : null;
  return prev && prev.to === clip.from ? clip.from + 0.5 : clip.from - 0.5;
}

function pointOf(anim, clips) {
  const clip = clips.find((c) => c.id === anim.clip);
  if (!clip) return null;
  const which = anim.at === "start" ? "start" : anim.at === "end" ? "end" : "middle";
  return clipPoint(clip, clips, which);
}

// 0 (hidden) or 1 (shown) at the given playhead frame — the state implied
// by every anims entry up to and including this point, latest wins. No
// entries at all means always shown (reference: `if (!list.length) return
// 1`), matching layers with no anims array.
export function evalLayerState(anims, clips, playheadFrame) {
  const points = anims
    .map((a) => ({ at: pointOf(a, clips), type: a.type }))
    .filter((p) => p.at !== null)
    .sort((a, b) => a.at - b.at);

  if (!points.length) return 1;

  let state = points[0].type === "show" ? 0 : 1;
  for (const p of points) {
    if (playheadFrame >= p.at) state = p.type === "show" ? 1 : 0;
  }
  return state;
}
